import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import {
  ApiPaginationResult,
  ApiResult,
} from '../../shared/models/api-result.model';
import { CreateCategory, UpdateCategory } from '../models/category.model';

@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  private http = inject(HttpClient);

  apiBaseUrl = environment.apiBaseUrl;

  getAll(
    pageNumber: number,
    pageSize: number,
    name?: string,
    description?: string,
    isActive?: boolean
  ) {
    let params = '';

    if (name) params += `&name=${name}`;
    if (description) params += `&description=${description}`;
    if (isActive) params += `&isActive=${isActive}`;

    return this.http.get<ApiPaginationResult>(
      this.apiBaseUrl +
        `/api/v1/categories?pageNumber=${pageNumber}&pageSize=${pageSize}${params}`
    );
  }

  getById(id: string) {
    return this.http.get<ApiResult>(
      this.apiBaseUrl + '/api/v1/categories/' + id
    );
  }

  getAllDropdown(parentCategoryId?: string) {
    let params = '';

    if (parentCategoryId) {
      params += `?parentCategoryId=${parentCategoryId}`;
    }
    return this.http.get<ApiResult>(
      this.apiBaseUrl + `/api/v1/categories/dropdown${params}`
    );
  }

  create(data: CreateCategory) {
    return this.http.post<ApiResult>(
      this.apiBaseUrl + '/api/v1/categories',
      data
    );
  }

  update(id: string, data: UpdateCategory) {
    return this.http.put<ApiResult>(
      this.apiBaseUrl + '/api/v1/categories/' + id,
      data
    );
  }

  updateStatus(id: string, isActive: boolean) {
    return this.http.patch<ApiResult>(
      this.apiBaseUrl + `/api/v1/categories/${id}/status`,
      { isActive }
    );
  }
}
